import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { getAttribution } from "@/lib/attribution";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const REGS = [["CQC", "CQC"], ["Ofsted", "Ofsted"], ["Aesthetics", "Aesthetics"], ["Healthcare", "GP & Hospitals"], ["Fostering", "Fostering agencies"]];

export default function NewsletterSignup({ source = "site", defaultRegulator = "CQC", compact = false }) {
  const [email, setEmail] = useState("");
  const [regulator, setRegulator] = useState(defaultRegulator);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, regulator, source, attribution: getAttribution() });
      setDone(data.message);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe");
    } finally { setBusy(false); }
  };

  if (done) {
    return <p className="inline-flex items-center gap-2 text-sm font-medium text-accent" data-testid="newsletter-success"><CheckCircle2 className="w-4 h-4" /> {done}</p>;
  }
  return (
    <form onSubmit={submit} className={`rounded-2xl border border-border bg-card p-6 shadow-sm ${compact ? "" : "md:flex md:items-end md:gap-4"}`} data-testid="newsletter-form">
      <div className="flex-1">
        <p className="font-display font-semibold flex items-center gap-2"><Mail className="w-4 h-4 text-primary" /> Weekly regulatory digest</p>
        <p className="text-sm text-muted-foreground mt-1 mb-3">New CQC / Ofsted publications and our latest guidance, every Monday. Unsubscribe any time.</p>
        <div className="flex gap-1.5 mb-3" data-testid="newsletter-regulator">
          {REGS.map(([id, label]) => (
            <button key={id} type="button" onClick={() => setRegulator(id)} data-testid={`newsletter-reg-${id.toLowerCase()}`}
              className={`px-3 py-1 rounded-full text-xs font-semibold border transition-colors ${regulator === id ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary/50"}`}>{label}</button>
          ))}
        </div>
      </div>
      <div className="flex gap-2 md:w-96">
        <Input type="email" required placeholder="you@yourservice.co.uk" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="newsletter-email" />
        <Button type="submit" disabled={busy} data-testid="newsletter-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Subscribe"}</Button>
      </div>
    </form>
  );
}
